import type { Offers } from "./offer.types";

export type OfferProps = {
  price: string;
  url: string;
  availability: string;
  priceCurrency: string;
};


export const getOfferSchema = ({
  price,
  url,
  availability,
  priceCurrency,
}: OfferProps): Offers => {
  return {
    "@type": "Offer",
    price,
    url,
    availability,
    priceCurrency,
  };
};